// extracted by mini-css-extract-plugin
export default {"close":"NestedPollQuestionForm_close__ATlnf"};